import { render } from "./gallery-past-events.vue?vue&type=template&id=6bc9da7c&scoped=true"
import script from "./gallery-past-events.vue?vue&type=script&lang=js"
export * from "./gallery-past-events.vue?vue&type=script&lang=js"

import "./gallery-past-events.vue?vue&type=style&index=0&id=6bc9da7c&scoped=true&lang=css"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc9da7c"]])

export default __exports__